import { atom } from 'recoil';
import { Api } from 'utils/services/Api';
import { ethers } from 'ethers';

export const web3Service = atom<any>({
  key: 'web3Service',
  default: new Api(),
});

export const addressState = atom<any>({
  key: 'addressState',
  default: undefined,
});

export const proxyState = atom<any>({
  key: 'proxyState',
  default: ethers.constants.AddressZero,
});
